import { render } from "./standard.vue?vue&type=template&id=6583d08f"
import script from "./standard.vue?vue&type=script&lang=js"
export * from "./standard.vue?vue&type=script&lang=js"

import "./standard.vue?vue&type=style&index=0&id=6583d08f&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/address-input/standard.vue'],['render',render],['__file',"standard.vue"]])

export default __exports__